<template>
<div class="d-md-none">
  <button type="button" class="btn btn-bars" :class="barButtonClass" @click="isOpen = !isOpen">
    <span class="top"></span>
    <span class="middle"></span>
    <span class="bottom"></span>
  </button>

  <div class="xs-menu d-flex flex-column justify-content-around align-items-center py-5" :class="{isOpen: isOpen}">
    <b-btn variant="outline-dark" class="" @click="clickMenu('#top')">TOP</b-btn>
    <b-btn variant="outline-dark" class="" @click="clickMenu('#profile')">PROFILE</b-btn>
    <b-btn variant="outline-dark" class="" @click="clickMenu('#artwork')">ARTWORK</b-btn>
    <b-btn variant="outline-dark" class="" @click="clickMenu('#order')">ORDER</b-btn>
    <b-btn variant="outline-dark" class="" @click="clickMenu('#workshop')">WORKSHOP</b-btn>
    <b-btn variant="outline-dark" class="" @click="clickMenu('#contact')">CONTACT</b-btn>
    <div>
      <a href="https://www.facebook.com/Hiraku91/" target="_blank" class="btn btn-outline-dark border-0 mr-4">
        <font-awesome-icon :icon="['fab', 'facebook']" size="lg" />
      </a>
      <a href="https://www.instagram.com/hiraku_ueda/" target="_blank" class="btn btn-outline-dark border-0">
        <font-awesome-icon :icon="['fab', 'instagram']" size="lg" />
      </a>

    </div>
  </div>
</div>  
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    ...mapState({
      homeSwiperIndex: state => state.homeSwiperIndex,
    }),
    barButtonClass() {
      if (this.isOpen) {
        return 'isOpen'
      } else {  
        if (this.$route.name == 'Home') {
          if (this.homeSwiperIndex == 0 || this.homeSwiperIndex == 1) {
            return 'white'
          }
        }
      }
      return ''
    }
  },
  methods: {
    ...mapActions({
      setHomeSwiperIndex: 'doSetHomeSwiperIndex',
      storePageControl: 'doSetPageControl',
      updatePageChange: 'doUpdatePageChanger'
    }),
    clickMenu(distination) {
      if (this.$route.name == 'Home') {
        if (location.hash == distination) {
          // そのまま閉じる
          this.isOpen = false
        } else {
          location.hash = distination
          this.updatePageChange()
          this.isOpen = false
        }
      } else {
        this.$router.push({name: 'Home', hash: distination})
        this.isOpen = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
$sidebar-width: 60px;
.btn-bars {
  position: fixed;
  top: 0;
  left: 0;
  width: $sidebar-width;
  height: $sidebar-width;
  display: block;
  background-color: transparent;
  z-index: 21;
  &:focus {
    box-shadow: none;
  }
}
$btn-bar-width: 30px;
.btn-bars {
  span {
    width: $btn-bar-width;
    height: 2px;
    display: block;
    background: #333;
    position: absolute;
    left: 50%;
    top: calc(50% - 1px);
    margin-left: -15px;
  }
  .top {
    transform: translateY(-11px) scale(1);
  }
  .middle {
    background: none;
    position: relative;
    &:after, &:before {
      transition: all 0.3s;
      content: "";
      width: $btn-bar-width;
      height: 2px;
      background-color: #333;
      display: block;
      transform: rotate(0deg);
      position: absolute;
    }
  }
  .bottom {
    transform: translateY(11px) scale(1);
    width: 20px;
  }
  span {
    transition: all 0.3s;
  }
  &.isOpen {
    .top {
      transform: translateY(0px) scale(0);
    }
    .middle:before {
      transform: rotate(45deg);
      background-color: #333 !important;
    }
    .middle:after {
      transform: rotate(-45deg);
      background-color: #333 !important;
    }
    .bottom {
      transform: translateY(0px) scale(0);
    }
  }
  &.white {
    span {
      background-color: #fff;
    }
    .middle {
      &:after, &:before {
        background-color: #fff;
      }
    }
  }
}
.xs-menu {
  position: fixed;
  z-index: 20;
  background-color: #fff;
  color: #333;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
  &.isOpen {
    pointer-events: inherit;
    opacity: 1;
  }
}

</style>